import CamerfirmaCard from './CamerfirmaCard';

export default CamerfirmaCard;
